module.exports = __webpack_public_path__ + "img/monarch-ui-icon_PUBLICATION.160b5af0.png";